import { Controller } from "stimulus"
import Litepicker from "litepicker";
import 'litepicker/dist/plugins/keyboardnav';
import 'litepicker/dist/plugins/mobilefriendly';
import 'litepicker/dist/plugins/ranges';
import {DataTable} from "simple-datatables"

export default class extends Controller {

  initialize() {
    this.setupFlatpickr();
    this.dataTable = new DataTable("#reportTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No calls found for date range given",
        info: "Showing {start} to {end} of {rows} calls"
      }
    });
    this.ourSearchBar = document.getElementById('reportSearchBar');
    this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    this.setupDataTableSearch();
  }

  setupFlatpickr() {
    let self=this;
    //Date picker with good accessibility support for screen readers
    flatpickr('#datepicker', {
      mode: "range",
      altInput: true,
      altFormat: "J F Y",
      dateFormat: "Y-m-d",
      defaultDate: this.getPickerDates(),
      onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length == 2) {
          // Both dates in the range have been selected
          self.setDateRange(selectedDates[0], selectedDates[1]);
          console.log(selectedDates, dateStr);
        }
      },
      onReady: function(dateObj, dateStr, instance) {
        const input = instance.altInput || instance.input;
        input.setAttribute('aria-label', 'Select date range for the report');
      }
    });
  }

  setDateRange(date1, date2){
    window.location.href = `${window.location.pathname}?start=${(date1.getTime()/1000).toString()}&end=${(date2.getTime()/1000).toString()}`
  }

  getPickerDates(){
   let searchParams = new URLSearchParams(window.location.search);
   let start = searchParams.get('start')
   let end = searchParams.get('end')
   if (start && end) {
     return [new Date(start * 1000), new Date(end * 1000)]
   } else {
     let date = new Date();
     return [new Date(date.getFullYear(), date.getMonth(), 1),
             new Date(date.getFullYear(), date.getMonth() + 1, 0)]
   }
  }

  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }
}
